import React, { useEffect, useState } from "react";
import IndexUniversalLifeData from "../Common/data/products/perm/PermData";
import PermCommonData from "../Common/data/products/perm";
import { Container, Col, Row } from 'react-bootstrap';
import Breadcrumb from '../Common/Breadcrumb/Breadcrumb';
import {Button,Box} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { Link, useHistory } from 'react-router-dom';
import { SESSION_STORAGE_CREATE_CASE, setSessionStorageItem, SESSION_STORAGE_CASE_RETURN_PATH, SESSION_STORAGE_PERM_LIFE_INSURANCE_OBJECT_KEY, SELECTED_PRODUCT_FOR_SUBMIT_A_CASE} from "../../sessionStorage";
import './Product.scss';
import "./permproduct.scss"
import { Helmet } from "react-helmet";

const useStyles = makeStyles((theme) => ({
  hyperlinks: {
    backgroundColor: 'white',
    marginLeft: '-25px',
    marginRight: '-25px',
    color: theme.palette.primary.main,
    boxShadow: '5px 3px 5px lightgrey',
  },
  activeLink: {
    borderBottom: `2px solid ${theme.palette.primary.main}`
  }
}));

const useButtonStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
}));

export default function PermProduct(){
  const classes = useStyles();
  const buttonStyle = useButtonStyles().button;
  const[commondata]=useState(PermCommonData())
  const[productname,setproductname]=useState('IndexUniversalLife')
  const[data,setdata]=useState(IndexUniversalLifeData(productname))
  const[activeTab, setActiveTab] = useState(0);
  const history = useHistory();

  useEffect(()=>{
    window.scrollTo(0,0);
    setdata(IndexUniversalLifeData(productname))
  },[productname])

  const offsetAnchor = (index) => {
    setActiveTab(index);
    switch(index){
      case 0:
        setproductname('IndexUniversalLife')
        break;
      case 1:
        setproductname('VariableUniversalLife')
        break;
      case 2:
        setproductname('UniversalLife')
        break;
      case 3:
        setproductname('Wholelife')
        break;
      default:
        return "";
    }
  }

  const onQuoteButtonClick = () => {
    sessionStorage.removeItem(SESSION_STORAGE_PERM_LIFE_INSURANCE_OBJECT_KEY)
    history.push('/Products/Perm');
  }

  const onSubmitButtonClick = (sessionkey) => {
    if (sessionkey) {
      sessionStorage.removeItem(sessionkey);
    }
    const selectedSubmitCaseProduct = {
      submitCaseProductKey: "PERM"
    }
    setSessionStorageItem(SELECTED_PRODUCT_FOR_SUBMIT_A_CASE, selectedSubmitCaseProduct);
    setSessionStorageItem(SESSION_STORAGE_CASE_RETURN_PATH, "/Products/Landing/perm-insurance")
    history.push('/Activity/NewCase/Client')
    return
  }

  const initiateButtonTitle = "Review permanent product solutions and illustrations with approved Insurance GA Partners";
  const caseDesignTitle = "Upload illustration design with Covr Insurance Planning Specialists to continue case via insurance Ticketing System";
  return (
    <div>
      <div className="product-tab">
        <Row className='perm-hero-image'>
          <div className='main-product'>
            <Container fluid >
              <Helmet>
                <title>Covr Advisor - {data.name}</title>
              </Helmet>
              <Row className="ml-3 mt-3">
                <Col>
                  <Row className="mb-4 mt-2">
                    <Breadcrumb breadcrumbLinks={[{ name: 'HOME', href: '/' }, { name: 'PRODUCTS', href: '/Products' }]} currentPage={'PERM LIFE INSURANCE'} />
                  </Row>
                  <Row className='mt-5'>
                    <Box fontSize={33}>
                      {commondata.name}
                    </Box>
                  </Row>
                </Col>
              </Row>
              <Row className="ml-3 my-2">
                <React.Fragment>
                  <Button variant="contained" color='primary' onClick={() => onQuoteButtonClick()} title={initiateButtonTitle}>Initiate Case Design</Button>
                  <Button variant="contained" color="primary" className='ml-3' title={caseDesignTitle} onClick={() => onSubmitButtonClick(SESSION_STORAGE_CREATE_CASE)}>Create Insurance Case</Button>
                </React.Fragment>
              </Row>
            </Container>
          </div>
        </Row>
        <Row className={classes.hyperlinks}>
          {commondata.hyperlinks.map((h, i) =>
            <Link key={i} smooth to={h.link} className={`sub-nav-link-button  ${activeTab === i ? classes.activeLink : null}`} onClick={() => offsetAnchor(i)}>
              <Button variant="text" className={buttonStyle}>{h.title.toUpperCase()}</Button>
            </Link>
          )}
        </Row>
      </div>
      <Row className="mt-4">
        <Col>
          <Container fluid className={'landing-content-container'}>
            <AboutData data={data.about} />
            <HowDoesitWork data={data.work} />
            <HowIsItUsed data={data.productuse} />
            <ProductFor data={data.productfor} />
            <HowToPurchase data={data.howtopurchase}/>
          </Container>
        </Col>
      </Row>
    </div>
  )
}

function AboutData(props) {
  const { data } = props;

  return (
    <div className="pl-2">
      <Row className="mb-4">
        <div>
          <div className="mb-3 product-title">{data.title}</div>
          {data.content.map((v,i)=>{
            return(
              <div className="product-content mt-2" key={i}>
                {v}
              </div>
            )
          })}
        </div>
      </Row>
    </div>
  )
}

function HowDoesitWork(props) {
  const { data } = props;

  return (
    <div className="pl-2">
      <Row className="mb-4">
        <div className="mb-3 product-title">{data.title}</div>
        <div>
          {data.content.map((v,i)=>{
            return(
              <div className="product-content mb-2"  key={i}>
                {v}
                <br />
              </div>
            )
          })
          }
        </div>
      </Row>
    </div>
  )
}

function HowIsItUsed(props) {
  const { data } = props;

  return (
    <div className="pl-2">
      <Row className="mb-2">
        <div>
          <div className="mb-2 product-title">{data.title}</div>
          <div className="product-content">
            {data.content}
          </div>
          <br />
        </div>
      </Row>
    </div>
  )
}
function ProductFor(props) {
  const { data } = props;

  return (
    <React.Fragment>
      {data && (
        <div className="pl-2">
          <Row>
            <div>
              <div className="mb-2 product-title">{data.title}</div>
              <div>{data.heading}</div>
              <ul>
                {data.paragraphs.map((v, i) =>
                  <li className="product-content" key={i}>{v}</li>
                )}
              </ul>
              <div>{data.headingsecond}</div>
              <ul>
                {data.paragraphsecond.map((v, i) =>
                  <li className="product-content" key={i}>{v}</li>
                )}
              </ul>
            </div>
          </Row>
        </div>
      )}
    </React.Fragment>
  )
}
function HowToPurchase(props) {
  const { data } = props;
  let history = useHistory();
  const  clearSession = () => {
    sessionStorage.removeItem(SESSION_STORAGE_PERM_LIFE_INSURANCE_OBJECT_KEY);
    history.push('/Products/Perm');
  }

  return (
    <div className="pl-2">
      <Row className="mb-4">
        <div>
          <div className="mb-2 product-title">{data.title}</div>
          <div className="mb-3 product-content">{data.contenttitle}<a className="redirect-link" onClick={() => clearSession()}>{data.linkcontent.toUpperCase()}</a></div>
          <div className="product-content" dangerouslySetInnerHTML= {{ __html: data.paragraphs}}></div>
          <br />
          <Container>

          </Container>
        </div>
      </Row>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ProductLanding/PermProduct.js